import React, { useContext, useEffect } from 'react'
import styled from 'styled-components'
import { SendPinCodeTemplate } from '../../templates/SendPinCodeTemplate'
import PropTypes from 'prop-types'
import { CountdownContext } from '../../../util/providers/CountdownProvider'
import { breakpoints } from '../../../util/medias'
import { getAttemptCheck, getAttemptCheckv2 } from '../../../api/attemptCheckAPI'
import { ArrowLeft } from '@olxbr/olx-icons/dist/System'

const PincodeWrapper = styled.div`
  max-width: 600px;
  flex: 1;
  flex-direction: column;
  margin: auto;
  @media screen and (min-width: ${breakpoints['mobile'] + 1}px) and (max-width: ${breakpoints[
      'tablet'
    ]}px) {
    width: 80vw;
  }
  @media screen and (max-width: ${breakpoints['mobile']}px) {
    margin: 0 auto;
    justify-content: center;
    margin-left: var(--spacing-2);
    margin-right: var(--spacing-2);
  }
`

const StyledText = styled.span.attrs({ className: 'typo-body-medium' })`
  display: block;
  margin-bottom: var(--spacing-2);
  @media screen and (max-width: ${breakpoints['mobile']}px) {
    font-size: var(--font-size-1-75);
  }
`

const StyledTitle = styled.span.attrs({ className: 'typo-title-large' })`
  display: block;
  margin-top: var(--spacing-4);
  @media screen and (max-width: ${breakpoints['mobile']}px) {
    margin-bottom: var(--spacing-2);
  }
  ${({ modalMode }) =>
    modalMode &&
    `
    margin-bottom: var(--spacing-1);
  `}
`

const StyledArrow = styled(ArrowLeft)`
  color: var(--color-neutral-130);
`

const ArrowContainer = styled.div`
  cursor: pointer;
  margin-bottom: var(--spacing-4);
`

export const SendPinCodePage = ({
  onSuccess,
  onClickBounce,
  onAlreadyHasCodeClick,
  showBounceLink,
  abTests,
  token,
  modalMode,
  onChooseSendMode,
}) => {
  const { lockTime, checkAttemptLockTime } = useContext(CountdownContext)

  const checkAttempt = () => (token ? getAttemptCheckv2(token) : getAttemptCheck())

  useEffect(() => {
    checkAttemptLockTime(checkAttempt)
  }, [])

  return (
    <PincodeWrapper>
      {!modalMode && showBounceLink && !token && (
        <ArrowContainer onClick={onClickBounce}>
          <StyledArrow />
        </ArrowContainer>
      )}
      {!modalMode && (
        <>
          <StyledTitle>Precisamos verificar seu telefone e fortalecer sua conta</StyledTitle>
          <StyledText>
            Informe seu número de telefone e receba o código de verificação pelo canal que preferir.
          </StyledText>
        </>
      )}
      {modalMode && (
        <StyledTitle modalMode={modalMode}>
          <span className="typo-title-medium">Verificação de telefone</span>
        </StyledTitle>
      )}
      <SendPinCodeTemplate
        onSuccess={onSuccess}
        onClickBounce={onClickBounce}
        onAlreadyHasCodeClick={onAlreadyHasCodeClick}
        showBounceLink={showBounceLink}
        lockTime={lockTime}
        abTests={abTests}
        token={token}
        modalMode={modalMode}
        onChooseSendMode={onChooseSendMode}
      />
    </PincodeWrapper>
  )
}

SendPinCodePage.propTypes = {
  onSuccess: PropTypes.func,
  onClickBounce: PropTypes.func,
  onAlreadyHasCodeClick: PropTypes.func,
  showBounceLink: PropTypes.bool,
  lockTime: PropTypes.number,
  abTests: PropTypes.string,
  token: PropTypes.string,
  modalMode: PropTypes.bool,
  onChooseSendMode: PropTypes.func,
}
